// PropVision — Elite Estate Demo Data

export const PROPERTIES = [
  {
    id: 'prop-1',
    name: 'Skyline Residences',
    location: 'Bandra West, Mumbai',
    price: '₹4.5 Cr',
    priceNum: 4.5,
    type: 'Apartment',
    config: '3 BHK',
    area: '2,200 sq.ft',
    totalUnits: 120,
    available: 45,
    status: 'ready',
    image: 'https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg?auto=compress&cs=tinysrgb&w=800',
    activeCampaigns: 3,
    totalLeads: 312,
    bookings: 8,
    description: 'Premium sea-view apartments in the heart of Bandra West with world-class amenities.',
    amenities: ['Swimming Pool', 'Gymnasium', 'Concierge', '4-Level Parking', 'Club House', 'Spa & Salon'],
    rera: 'P51900047765',
    gallery: [
      'https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg?auto=compress&cs=tinysrgb&w=800',
      'https://images.unsplash.com/photo-1738168251394-9241984c8292?w=800&q=80',
      'https://images.unsplash.com/photo-1680210849773-f97a41c6b7ed?w=800&q=80',
    ]
  },
  {
    id: 'prop-2',
    name: 'Palm Gardens Villa',
    location: 'Golf Course Road, Gurgaon',
    price: '₹8.5 Cr',
    priceNum: 8.5,
    type: 'Villa',
    config: '4 BHK',
    area: '4,500 sq.ft',
    totalUnits: 45,
    available: 12,
    status: 'construction',
    image: 'https://images.unsplash.com/photo-1622015663381-d2e05ae91b72?w=800&q=80',
    activeCampaigns: 2,
    totalLeads: 189,
    bookings: 5,
    description: 'Exclusive gated villa community with private pool and landscaped gardens on Golf Course Road.',
    amenities: ['Private Pool', 'Home Theater', 'Modular Kitchen', 'Servant Quarters', 'Smart Home', 'EV Charging'],
    rera: 'RERA-HR-2024-0156',
    gallery: [
      'https://images.unsplash.com/photo-1622015663381-d2e05ae91b72?w=800&q=80',
      'https://images.unsplash.com/photo-1738168246881-40f35f8aba0a?w=800&q=80',
      'https://images.pexels.com/photos/3144580/pexels-photo-3144580.jpeg?auto=compress&cs=tinysrgb&w=800',
    ]
  },
  {
    id: 'prop-3',
    name: 'The Grand Penthouse',
    location: 'Whitefield, Bangalore',
    price: '₹12 Cr',
    priceNum: 12,
    type: 'Penthouse',
    config: '5 BHK',
    area: '6,500 sq.ft',
    totalUnits: 12,
    available: 3,
    status: 'ready',
    image: 'https://images.pexels.com/photos/430216/pexels-photo-430216.jpeg?auto=compress&cs=tinysrgb&w=800',
    activeCampaigns: 2,
    totalLeads: 89,
    bookings: 2,
    description: 'Ultra-luxury penthouses with 360° city views, private terrace, and dedicated concierge service.',
    amenities: ['Private Terrace', 'Infinity Pool', 'Home Automation', 'Butler Service', 'Wine Cellar', 'Helipad Access'],
    rera: 'PRM/KA/RERA/1251/446',
    gallery: [
      'https://images.pexels.com/photos/430216/pexels-photo-430216.jpeg?auto=compress&cs=tinysrgb&w=800',
      'https://images.unsplash.com/photo-1738168279272-c08d6dd22002?w=800&q=80',
      'https://images.unsplash.com/photo-1640109478916-f445f8f19b11?w=800&q=80',
    ]
  },
  {
    id: 'prop-4',
    name: 'Marina Bay Towers',
    location: 'ECR, Chennai',
    price: '₹2.8 Cr',
    priceNum: 2.8,
    type: 'Apartment',
    config: '2 BHK',
    area: '1,450 sq.ft',
    totalUnits: 200,
    available: 78,
    status: 'ready',
    image: 'https://images.unsplash.com/photo-1622015663319-e97e697503ee?w=800&q=80',
    activeCampaigns: 1,
    totalLeads: 445,
    bookings: 15,
    description: 'Modern seafront apartments with breathtaking Bay of Bengal views and premium amenities.',
    amenities: ['Rooftop Pool', 'Co-working Space', 'Kids Play Area', 'Jogging Track', 'Community Hall', 'Beach Access'],
    rera: 'TN/01/Building/0521',
    gallery: [
      'https://images.unsplash.com/photo-1622015663319-e97e697503ee?w=800&q=80',
      'https://images.unsplash.com/photo-1738168273959-952fdc961991?w=800&q=80',
    ]
  },
  {
    id: 'prop-5',
    name: 'Heritage Heights',
    location: 'Koregaon Park, Pune',
    price: '₹3.2 Cr',
    priceNum: 3.2,
    type: 'Apartment',
    config: '3 BHK',
    area: '1,800 sq.ft',
    totalUnits: 80,
    available: 28,
    status: 'construction',
    image: 'https://images.pexels.com/photos/7031600/pexels-photo-7031600.jpeg?auto=compress&cs=tinysrgb&w=800',
    activeCampaigns: 1,
    totalLeads: 234,
    bookings: 6,
    description: "Heritage-inspired modern living in Pune's most premium neighborhood with vintage charm.",
    amenities: ['Heritage Garden', 'Library', 'Yoga Studio', 'Pet Zone', 'Senior Citizen Area', 'Rooftop Lounge'],
    rera: 'P52100028321',
    gallery: [
      'https://images.pexels.com/photos/7031600/pexels-photo-7031600.jpeg?auto=compress&cs=tinysrgb&w=800',
      'https://images.pexels.com/photos/7031708/pexels-photo-7031708.jpeg?auto=compress&cs=tinysrgb&w=800',
    ]
  },
  {
    id: 'prop-6',
    name: 'Royal Enclave',
    location: 'Jubilee Hills, Hyderabad',
    price: '₹6.5 Cr',
    priceNum: 6.5,
    type: 'Villa',
    config: '4 BHK',
    area: '3,800 sq.ft',
    totalUnits: 30,
    available: 8,
    status: 'ready',
    image: 'https://images.unsplash.com/photo-1622015663084-307d19eabbbf?w=800&q=80',
    activeCampaigns: 2,
    totalLeads: 156,
    bookings: 4,
    description: "Vastu-compliant luxury villas in Hyderabad's most prestigious gated community with Italian marble.",
    amenities: ['Italian Marble', 'Vastu Compliant', 'Private Garden', 'Smart Security', 'Guest Suite', 'Clubhouse'],
    rera: 'P02400003456',
    gallery: [
      'https://images.unsplash.com/photo-1622015663084-307d19eabbbf?w=800&q=80',
      'https://images.pexels.com/photos/7031608/pexels-photo-7031608.jpeg?auto=compress&cs=tinysrgb&w=800',
    ]
  }
];

export const PIPELINE_STAGES = [
  { id: 'new', label: 'New Lead', color: 'bg-slate-100 text-slate-700', dot: 'bg-slate-400' },
  { id: 'whatsapp_connected', label: 'WhatsApp', color: 'bg-green-50 text-green-700', dot: 'bg-green-500' },
  { id: 'ai_called', label: 'AI Called', color: 'bg-purple-50 text-purple-700', dot: 'bg-purple-500' },
  { id: 'qualified', label: 'Qualified', color: 'bg-blue-50 text-blue-700', dot: 'bg-blue-500' },
  { id: 'site_visit', label: 'Site Visit', color: 'bg-orange-50 text-orange-700', dot: 'bg-orange-500' },
  { id: 'negotiation', label: 'Negotiation', color: 'bg-yellow-50 text-yellow-700', dot: 'bg-yellow-500' },
  { id: 'booked', label: 'Booked', color: 'bg-emerald-50 text-emerald-700', dot: 'bg-emerald-500' },
];

export const LEADS = [
  { id: 'lead-1', name: 'Rahul Sharma', phone: '+91 98765 43210', email: 'rahul.sharma@gmail.com', source: 'meta', propertyInterest: 'Skyline Residences', budget: '4–5 Cr', config: '3 BHK', stage: 'qualified', assignedTo: 'Priya Kapoor', avatar: 'RS', location: 'Mumbai', score: 87, notes: 'Interested in sea-view floor. Ready to pay advance.', createdAt: 'Jan 15, 2024', lastActivity: '2 hrs ago', daysInPipeline: 8 },
  { id: 'lead-2', name: 'Ananya Patel', phone: '+91 99887 65432', email: 'ananya.p@yahoo.com', source: 'google', propertyInterest: 'Palm Gardens Villa', budget: '8–10 Cr', config: '4 BHK', stage: 'site_visit', assignedTo: 'Rohan Mehta', avatar: 'AP', location: 'Gurgaon', score: 92, notes: 'NRI buyer. Ready for site visit on Saturday.', createdAt: 'Jan 12, 2024', lastActivity: '1 day ago', daysInPipeline: 12 },
  { id: 'lead-3', name: 'Vikram Singh', phone: '+91 97654 32109', email: 'vikram.s@hotmail.com', source: 'whatsapp', propertyInterest: 'The Grand Penthouse', budget: '12–15 Cr', config: '5 BHK', stage: 'negotiation', assignedTo: 'Priya Kapoor', avatar: 'VS', location: 'Bangalore', score: 95, notes: 'Price negotiation in progress. Very serious buyer.', createdAt: 'Jan 8, 2024', lastActivity: '3 hrs ago', daysInPipeline: 16 },
  { id: 'lead-4', name: 'Meera Reddy', phone: '+91 88776 54321', email: 'meera.r@gmail.com', source: 'meta', propertyInterest: 'Royal Enclave', budget: '6–7 Cr', config: '4 BHK', stage: 'booked', assignedTo: 'Amit Desai', avatar: 'MR', location: 'Hyderabad', score: 100, notes: 'Booking done! 10% advance paid.', createdAt: 'Jan 5, 2024', lastActivity: '2 days ago', daysInPipeline: 21 },
  { id: 'lead-5', name: 'Arjun Nair', phone: '+91 76543 21098', email: 'arjun.nair@gmail.com', source: 'meta', propertyInterest: 'Marina Bay Towers', budget: '2.5–3 Cr', config: '2 BHK', stage: 'new', assignedTo: null, avatar: 'AN', location: 'Chennai', score: 45, notes: '', createdAt: 'Jan 22, 2024', lastActivity: 'Just now', daysInPipeline: 0 },
  { id: 'lead-6', name: 'Kavita Gupta', phone: '+91 87654 32198', email: 'kavita.g@gmail.com', source: 'whatsapp', propertyInterest: 'Heritage Heights', budget: '3–4 Cr', config: '3 BHK', stage: 'whatsapp_connected', assignedTo: 'Rohan Mehta', avatar: 'KG', location: 'Pune', score: 62, notes: 'Replied on WhatsApp. Exploring options.', createdAt: 'Jan 21, 2024', lastActivity: '4 hrs ago', daysInPipeline: 2 },
  { id: 'lead-7', name: 'Sanjay Kumar', phone: '+91 96543 21876', email: 'sanjay.k@outlook.com', source: 'google', propertyInterest: 'Skyline Residences', budget: '4–6 Cr', config: '3 BHK', stage: 'ai_called', assignedTo: 'Priya Kapoor', avatar: 'SK', location: 'Mumbai', score: 71, notes: 'AI call completed. Very interested in 15th floor view.', createdAt: 'Jan 20, 2024', lastActivity: '6 hrs ago', daysInPipeline: 3 },
  { id: 'lead-8', name: 'Deepika Joshi', phone: '+91 85432 10987', email: 'deepika.j@gmail.com', source: 'meta', propertyInterest: 'Palm Gardens Villa', budget: '7–9 Cr', config: '4 BHK', stage: 'site_visit', assignedTo: 'Amit Desai', avatar: 'DJ', location: 'Gurgaon', score: 88, notes: 'Site visit scheduled for Jan 25.', createdAt: 'Jan 14, 2024', lastActivity: '1 day ago', daysInPipeline: 10 },
  { id: 'lead-9', name: 'Ravi Krishnan', phone: '+91 74321 09876', email: 'ravi.k@gmail.com', source: 'meta', propertyInterest: 'Marina Bay Towers', budget: '2.5–3 Cr', config: '2 BHK', stage: 'new', assignedTo: null, avatar: 'RK', location: 'Chennai', score: 38, notes: '', createdAt: 'Jan 22, 2024', lastActivity: '30 min ago', daysInPipeline: 0 },
  { id: 'lead-10', name: 'Pooja Agarwal', phone: '+91 93456 78901', email: 'pooja.a@yahoo.com', source: 'whatsapp', propertyInterest: 'Heritage Heights', budget: '3–3.5 Cr', config: '3 BHK', stage: 'ai_called', assignedTo: 'Rohan Mehta', avatar: 'PA', location: 'Pune', score: 68, notes: 'Interested in amenities. AI call went well.', createdAt: 'Jan 19, 2024', lastActivity: '8 hrs ago', daysInPipeline: 4 },
  { id: 'lead-11', name: 'Aditya Verma', phone: '+91 82345 67890', email: 'aditya.v@gmail.com', source: 'google', propertyInterest: 'Royal Enclave', budget: '6–8 Cr', config: '4 BHK', stage: 'qualified', assignedTo: 'Amit Desai', avatar: 'AV', location: 'Hyderabad', score: 81, notes: 'Confirmed budget. Planning to invest.', createdAt: 'Jan 17, 2024', lastActivity: '5 hrs ago', daysInPipeline: 6 },
  { id: 'lead-12', name: 'Neha Malhotra', phone: '+91 91234 56789', email: 'neha.m@gmail.com', source: 'meta', propertyInterest: 'The Grand Penthouse', budget: '10–12 Cr', config: '5 BHK', stage: 'negotiation', assignedTo: 'Priya Kapoor', avatar: 'NM', location: 'Bangalore', score: 91, notes: 'Negotiating on interior package. Very interested.', createdAt: 'Jan 10, 2024', lastActivity: '2 hrs ago', daysInPipeline: 14 },
  { id: 'lead-13', name: 'Suresh Pillai', phone: '+91 80123 45678', email: 'suresh.p@gmail.com', source: 'whatsapp', propertyInterest: 'Skyline Residences', budget: '4–5 Cr', config: '3 BHK', stage: 'whatsapp_connected', assignedTo: null, avatar: 'SP', location: 'Mumbai', score: 55, notes: 'Responded to WhatsApp. Needs more info.', createdAt: 'Jan 21, 2024', lastActivity: '3 hrs ago', daysInPipeline: 2 },
  { id: 'lead-14', name: 'Priyanka Nair', phone: '+91 79012 34567', email: 'priyanka.n@hotmail.com', source: 'meta', propertyInterest: 'Marina Bay Towers', budget: '2.8–3.5 Cr', config: '2 BHK', stage: 'booked', assignedTo: 'Rohan Mehta', avatar: 'PN', location: 'Chennai', score: 100, notes: 'Booked 8th floor, sea-facing unit.', createdAt: 'Jan 3, 2024', lastActivity: '3 days ago', daysInPipeline: 19 },
  { id: 'lead-15', name: 'Manish Chopra', phone: '+91 78901 23456', email: 'manish.c@gmail.com', source: 'google', propertyInterest: 'Palm Gardens Villa', budget: '8–10 Cr', config: '4 BHK', stage: 'site_visit', assignedTo: 'Amit Desai', avatar: 'MC', location: 'Gurgaon', score: 79, notes: 'Second site visit. Very interested.', createdAt: 'Jan 13, 2024', lastActivity: '1 day ago', daysInPipeline: 11 },
];

export const CAMPAIGNS = [
  { id: 'camp-1', name: 'Skyline Residences — Bandra Launch', property: 'Skyline Residences', type: 'meta', status: 'active', dailyBudget: 5000, totalSpent: 125000, leads: 312, cpl: 401, roas: 4.2, aiScore: 87, startDate: 'Jan 1, 2024', target: 'Mumbai, Age 28–45, HNI' },
  { id: 'camp-2', name: 'Palm Gardens — Premium Villas Gurgaon', property: 'Palm Gardens Villa', type: 'meta', status: 'active', dailyBudget: 8000, totalSpent: 195000, leads: 189, cpl: 1032, roas: 3.8, aiScore: 74, startDate: 'Jan 5, 2024', target: 'Delhi NCR, Age 35–55, Ultra HNI' },
  { id: 'camp-3', name: 'Grand Penthouse — Google Search', property: 'The Grand Penthouse', type: 'google', status: 'active', dailyBudget: 3000, totalSpent: 67000, leads: 89, cpl: 753, roas: 5.1, aiScore: 91, startDate: 'Jan 8, 2024', target: 'Bangalore, CXO searches' },
  { id: 'camp-4', name: 'Heritage Heights — WhatsApp Blast', property: 'Heritage Heights', type: 'whatsapp', status: 'active', dailyBudget: 1500, totalSpent: 28000, leads: 234, cpl: 120, roas: 6.3, aiScore: 79, startDate: 'Jan 10, 2024', target: 'Pune contacts database' },
  { id: 'camp-5', name: 'Royal Enclave — Landing Page', property: 'Royal Enclave', type: 'landing_page', status: 'paused', dailyBudget: 4000, totalSpent: 89000, leads: 156, cpl: 571, roas: 3.2, aiScore: 65, startDate: 'Dec 20, 2023', target: 'Hyderabad, NRI investors' },
];

export const CONVERSATIONS = [
  {
    id: 'conv-1', leadId: 'lead-1', leadName: 'Rahul Sharma', avatar: 'RS', channel: 'whatsapp',
    lastMessage: 'Yes, I am available this weekend for a site visit', time: '2 min ago', unread: 2,
    stage: 'qualified', propertyInterest: 'Skyline Residences', budget: '4–5 Cr',
    messages: [
      { id: 'm1', from: 'agent', text: "Hi Rahul! I'm Sarah from Elite Estate. You recently showed interest in Skyline Residences. Are you still looking for a 3 BHK?", time: '10:05 AM' },
      { id: 'm2', from: 'lead', text: 'Yes, I saw the ad. What\'s the starting price?', time: '10:08 AM' },
      { id: 'm3', from: 'agent', text: '3 BHK units start at ₹4.5 Cr. We have sea-view and garden-view options. The tower also has a rooftop infinity pool, spa, and 4-level parking.', time: '10:08 AM' },
      { id: 'm4', from: 'lead', text: 'Sure, share the brochure', time: '10:12 AM' },
      { id: 'm5', from: 'agent', text: '📄 Skyline Residences Brochure — Elite Estate.pdf', time: '10:13 AM', isFile: true },
      { id: 'm6', from: 'lead', text: 'Looks great! Can we schedule a site visit?', time: '10:45 AM' },
      { id: 'm7', from: 'agent', text: 'Absolutely! We have slots this Saturday (10 AM – 2 PM) and Sunday (11 AM – 4 PM). Which works?', time: '10:46 AM' },
      { id: 'm8', from: 'lead', text: 'Yes, I am available this weekend for a site visit', time: '2 min ago' },
    ]
  },
  {
    id: 'conv-2', leadId: 'lead-2', leadName: 'Ananya Patel', avatar: 'AP', channel: 'ai_call',
    lastMessage: 'AI Call completed — 12 mins. Interested in 4 BHK with pool view.', time: '1 hr ago', unread: 0,
    stage: 'site_visit', propertyInterest: 'Palm Gardens Villa', budget: '8–10 Cr',
    transcript: [
      { speaker: 'AI', text: 'Good afternoon, may I speak with Ananya Patel?', time: '0:03' },
      { speaker: 'Lead', text: 'Yes, speaking.', time: '0:06' },
      { speaker: 'AI', text: "Hi Ananya! I'm calling from Elite Estate regarding Palm Gardens Villa in Golf Course Road. Is this a good time?", time: '0:08' },
      { speaker: 'Lead', text: 'Yes sure, I was actually waiting for your call.', time: '0:20' },
      { speaker: 'AI', text: "Great! Palm Gardens is an exclusive collection of 45 luxury villas starting at ₹8.5 Cr. Are you looking for self-use or investment?", time: '0:28' },
      { speaker: 'Lead', text: "Both actually. I'm an NRI and want a good investment I can also use during visits.", time: '0:48' },
      { speaker: 'AI', text: 'Perfect. Our villas deliver 5–6% rental yield and 15% capital appreciation in the last 2 years. Each villa has a private pool and smart home automation.', time: '1:05' },
      { speaker: 'Lead', text: 'That sounds amazing. What\'s the possession timeline?', time: '1:35' },
      { speaker: 'AI', text: 'Possession is Q3 2025. We are at 65% construction and fully RERA registered.', time: '1:45' },
      { speaker: 'Lead', text: "I'd like to visit when I'm in Gurgaon next week.", time: '2:10' },
      { speaker: 'AI', text: "I'll connect you with Rohan Mehta for a premium site visit. Can I confirm next Saturday at 11 AM?", time: '2:20' },
      { speaker: 'Lead', text: 'Yes, that works perfectly.', time: '2:45' },
    ]
  },
  {
    id: 'conv-3', leadId: 'lead-3', leadName: 'Vikram Singh', avatar: 'VS', channel: 'whatsapp',
    lastMessage: 'Can you match 11.5 Cr all-inclusive with modular kitchen?', time: '3 hrs ago', unread: 1,
    stage: 'negotiation', propertyInterest: 'The Grand Penthouse', budget: '12–15 Cr',
    messages: [
      { id: 'm1', from: 'agent', text: "Good morning Vikram! Following up on The Grand Penthouse. Our team is ready to start the documentation process.", time: '9:00 AM' },
      { id: 'm2', from: 'lead', text: "I'm interested but the price needs to come down a bit.", time: '9:30 AM' },
      { id: 'm3', from: 'agent', text: 'I understand. What price point would you be comfortable with?', time: '9:32 AM' },
      { id: 'm4', from: 'lead', text: 'Can you match 11.5 Cr all-inclusive with modular kitchen?', time: '3 hrs ago' },
    ]
  },
  {
    id: 'conv-4', leadId: 'lead-7', leadName: 'Sanjay Kumar', avatar: 'SK', channel: 'ai_call',
    lastMessage: 'AI Call — 8 mins. Shortlisted 15th floor unit, ₹5.2 Cr.', time: '6 hrs ago', unread: 0,
    stage: 'ai_called', propertyInterest: 'Skyline Residences', budget: '4–6 Cr',
    transcript: [
      { speaker: 'AI', text: 'Hi, is this Sanjay Kumar?', time: '0:02' },
      { speaker: 'Lead', text: "Yes, who's calling?", time: '0:05' },
      { speaker: 'AI', text: "This is from Elite Estate. You enquired about Skyline Residences. We've just released premium 15th floor sea-view units.", time: '0:10' },
      { speaker: 'Lead', text: 'Oh interesting! How much are the 15th floor ones?', time: '0:35' },
      { speaker: 'AI', text: 'The 15th floor 3 BHK units are ₹5.2 Cr, including a 1,500 sq.ft private terrace with panoramic sea views. Only 2 units remaining.', time: '0:45' },
      { speaker: 'Lead', text: "That's a bit over my budget of 4.5 but I can stretch for a sea view. Can I visit?", time: '1:20' },
    ]
  },
  {
    id: 'conv-5', leadId: 'lead-6', leadName: 'Kavita Gupta', avatar: 'KG', channel: 'whatsapp',
    lastMessage: 'What are the payment plan options?', time: '4 hrs ago', unread: 3,
    stage: 'whatsapp_connected', propertyInterest: 'Heritage Heights', budget: '3–4 Cr',
    messages: [
      { id: 'm1', from: 'agent', text: "Hello Kavita! Welcome to Elite Estate. You expressed interest in Heritage Heights, Koregaon Park. How can I help?", time: '2:00 PM' },
      { id: 'm2', from: 'lead', text: 'Hi! I saw your ad. Is it really in Koregaon Park?', time: '2:05 PM' },
      { id: 'm3', from: 'agent', text: "Yes! Heritage Heights is in the heart of Koregaon Park. 3 BHK units starting at ₹3.2 Cr.", time: '2:06 PM' },
      { id: 'm4', from: 'lead', text: 'What are the payment plan options?', time: '4 hrs ago' },
    ]
  },
];

export const MONTHLY_DATA = [
  { month: 'Aug', leads: 89, qualified: 34, siteVisits: 18, bookings: 4, revenue: 5.4 },
  { month: 'Sep', leads: 112, qualified: 45, siteVisits: 23, bookings: 7, revenue: 8.2 },
  { month: 'Oct', leads: 145, qualified: 58, siteVisits: 31, bookings: 9, revenue: 11.5 },
  { month: 'Nov', leads: 167, qualified: 71, siteVisits: 38, bookings: 12, revenue: 15.8 },
  { month: 'Dec', leads: 198, qualified: 89, siteVisits: 47, bookings: 15, revenue: 19.2 },
  { month: 'Jan', leads: 234, qualified: 108, siteVisits: 56, bookings: 18, revenue: 24.6 },
];

export const CAMPAIGN_PERFORMANCE = [
  { name: 'Meta Ads', leads: 501, qualified: 189, spent: 320000, cpl: 639 },
  { name: 'Google Ads', leads: 89, qualified: 67, spent: 67000, cpl: 753 },
  { name: 'WhatsApp', leads: 234, qualified: 134, spent: 28000, cpl: 120 },
  { name: 'Landing Page', leads: 156, qualified: 78, spent: 89000, cpl: 571 },
];

export const LEAD_SOURCES = [
  { name: 'Meta Ads', value: 50, color: '#2563eb' },
  { name: 'WhatsApp', value: 23, color: '#3b82f6' },
  { name: 'Google Ads', value: 18, color: '#60a5fa' },
  { name: 'Direct', value: 9, color: '#93c5fd' },
];

export const TEAM_PERFORMANCE = [
  { name: 'Priya Kapoor', leads: 145, qualified: 67, bookings: 8, revenue: 38.5 },
  { name: 'Rohan Mehta', leads: 112, qualified: 54, bookings: 6, revenue: 28.2 },
  { name: 'Amit Desai', leads: 98, qualified: 41, bookings: 5, revenue: 22.8 },
  { name: 'Sneha Rao', leads: 87, qualified: 33, bookings: 4, revenue: 18.6 },
];

export const FUNNEL_DATA = [
  { stage: 'New Leads', count: 1247, pct: 100 },
  { stage: 'WhatsApp Connected', count: 856, pct: 69 },
  { stage: 'AI Called', count: 634, pct: 51 },
  { stage: 'Qualified', count: 408, pct: 33 },
  { stage: 'Site Visit', count: 267, pct: 21 },
  { stage: 'Negotiation', count: 145, pct: 12 },
  { stage: 'Booked', count: 54, pct: 4 },
];

export const AI_INSIGHTS = [
  { id: 1, type: 'opportunity', title: '12 High-Intent Mumbai Leads', message: "12 leads from Mumbai haven't been called in 3+ days. AI confidence: 78% booking probability if contacted today.", action: 'Assign to Priya Kapoor', time: '2 hrs ago' },
  { id: 2, type: 'warning', title: 'Palm Gardens CPL Rising', message: 'Meta campaign CPL increased 23% this week. Recommend adjusting targeting to Golf Course Extension area.', action: 'Review Campaign', time: '4 hrs ago' },
  { id: 3, type: 'success', title: 'AI Call Success Rate Up', message: 'AI call connection rate improved to 76% (from 61% last week) after updating call script with vernacular support.', action: 'View Analytics', time: '1 day ago' },
  { id: 4, type: 'opportunity', title: 'WhatsApp Re-engagement', message: '34 leads went cold after initial WhatsApp contact 7+ days ago. AI recommends sending a property update message.', action: 'Launch Sequence', time: '1 day ago' },
];

export const SITE_VISITS = [
  { id: 'sv-1', leadName: 'Ananya Patel', property: 'Palm Gardens Villa', date: 'Saturday, Jan 27', time: '11:00 AM', agent: 'Rohan Mehta', status: 'confirmed' },
  { id: 'sv-2', leadName: 'Rahul Sharma', property: 'Skyline Residences', date: 'Saturday, Jan 27', time: '2:00 PM', agent: 'Priya Kapoor', status: 'confirmed' },
  { id: 'sv-3', leadName: 'Deepika Joshi', property: 'Palm Gardens Villa', date: 'Sunday, Jan 28', time: '10:00 AM', agent: 'Amit Desai', status: 'pending' },
  { id: 'sv-4', leadName: 'Manish Chopra', property: 'Palm Gardens Villa', date: 'Sunday, Jan 28', time: '3:00 PM', agent: 'Amit Desai', status: 'confirmed' },
];
